module.exports = __webpack_public_path__ + "img/BuildingInformation.bbfb93e4.png";